{
  "aria.profileImage": "Profilbilde",
  "chooseIndustries": "Velg bransje",
  "chooseIndustriesText": "Velg bransjer deres kunder eller bedrifter jobber innenfor",
  "heading": "Aktørprofil",
  "edit": "Rediger",
  "editProfile": "Rediger profil",
  "editActorProfile": "Rediger aktørprofil",
  "firstLineService": "Førstelinjetjeneste for",
  "generalInfo.commonEmail": "Felles e-post",
  "generalInfo.heading": "Generell informasjon",
  "generalInfo.optional": "Vi anbefaler å fylle ut så mange av feltene som mulig for å øke synligheten til\n        organisasjonen.",
  "logo": "Logo",
  "mainContact": "Hovedkontakt",
  "update": "Oppdater aktørprofil",
  "update.success": "Aktørprofil har blitt oppdatert",
  "update.failure.heading": "Beklager, vi kunne ikke oppdatere Aktørprofil",
  "update.failure.text": "Kontroller feltene og prøv igjen, eller kontakt oss på ",
  "noActor": "Ingen aktørinformasjon ble funnet",
  "noDescription": "Ingen beskrivelse er lagt til enda",
  "noDescription.cta": "Andre aktører kan ikke se beskrivelsen deres",
  "noLogo": "Ingen logo er lastet opp",
  "noMainContact": "Ingen hovedkontakt er registrert",
  "noIndustry": "Ingen bransje er lagt til",
  "portfolioIndustries": "Bransjer innen porteføljen",
  "services": "Tjenester",
  "goToCatalog": "Gå til Felles Tjenestekatalog",
  "workAreas": "Arbeidsområder",
  "showProfile": "Visning av aktørprofil",
  "loggedInAs": "Du er logget inn som {{ user }} for {{ actor }}.",
  "addViaAccessControl": "Finner du ikke ansatte her eller vil du endre informasjonen til en ansatt? Du kan legge til ansatte eller endre informasjon i ",
  "informationSaved": "Informasjonen er lagret",
  "employeePhoto": "Ansattbilde",
  "mainContactPhoto": "Hovedkontaktbilde",
  "actorLogo": "Aktørlogo",
  "services.readMore": "Les mer om tjenestene i",
  "companyAgeRequirement": "Krav til bedriftens alder",
  "companySize": "Krav til bedriftsstørrelse",
  "commonServiceCatalogue": "Felles tjenestekatalog",
  "noServices": "Ingen tjenester tilgjengelig, legg til tjenester i",
  "name": "Navn",
  "phone": "Tlf",
  "email": "E-post",
  "contactPerson": "Kontaktperson",
  "required.address": "Adresse må fylles ut",
  "required.postalCode": "Postnummer må fylles ut og være et fire-sifret tall"
}
